<div class="upgrade-indicator" [ngClass]="{ clickable: !hideUpgrade }" (click)="click()" (keydown.enter)="click()" tabindex="0">
  <la-circle-chart [value]="value" [max]="max"></la-circle-chart>
  <div class="text-wrapper" [ngClass]="{ 'display-column': item === 'plans' }">
    <div class="label">{{ value }}/{{ max }} free {{ item }} used</div>

    @if (!hideUpgrade) {
      <span class="upgrade-text">Upgrade for unlimited {{ item }}</span>
    }
  </div>
</div>
